<mat-toolbar color="primary">Stripe Integration</mat-toolbar>

<mat-dialog-content>
  @if (hasStripeIntegration$ | async) {
    <p>You are connected with Stripe!</p>
  } @else {
    @if (!loading) {
      <a (click)="openStripeConnect()">
        <pt-stripe-connect-button />
      </a>
    } @else {
      <div class="flex justify-center gap-2">
        <mat-spinner diameter="24" />
        <span>Connecting with Stripe. A new window will open soon.</span>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button type="button" mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
